import React from "react";
import "./SubTitle.scss";
import { useNavigate } from "react-router-dom";

export default function SubTitle(props) {
  // eslint-disable-next-line react/prop-types
  const { text } = props;
  let navigate = useNavigate();
  const goToLoginText = () => {
    navigate("/login/text");
  };
  return (
    <div
      style={{
        background: "#5b5b5b",
        color: "#FFFFFF",
        height: "30px",
        textAlign: "center",
        cursor: "pointer",
        fontWeight: "500",
      }}
      onClick={goToLoginText}
    >
      {text}
    </div>
  );
}
